<template>
  <div id="branchesComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout class="mb-2" row wrap>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="branchSearch"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search">
        </v-text-field>
          <v-dialog
            persistent
            v-model="dialog"
            max-width="700px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                round
                outline
                v-on="on"
              >
                <v-icon left>add</v-icon>
                {{ $t('branch.add') }}
              </v-btn>
            </template>
            <v-card>
              <v-toolbar
                flat
              >
                <h2 class="font-weight-black primary--text mb-0">{{formTitle}}</h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-xs>
                  <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                  >
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          clearable
                          required
                          :rules="rules.textRules"
                          :label="$t('general.name')"
                          :error-messages="errors.branch_name"
                          v-model="editedItem.branch_name"
                          @keyup.enter="save"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          clearable
                          required
                          :rules="rules.textRules"
                          :label="$t('address.street')"
                          :error-messages="errors.street"
                          v-model="editedItem.street"
                          @keyup.enter="save"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          clearable
                          required
                          :rules="rules.textRules"
                          :label="$t('address.city')"
                          :error-messages="errors.city"
                          v-model="editedItem.city"
                          @keyup.enter="save"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          clearable
                          required
                          :rules="rules.textRules"
                          :label="$t('address.state')"
                          :error-messages="errors.state"
                          v-model="editedItem.state"
                          @keyup.enter="save"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete
                          required
                          :items="items"
                          item-value="id"
                          item-text="descripcion"
                          :search-input.sync="search"
                          :filter="dataArrayFilter.filter"
                          :rules="rules.required"
                          :error-messages="errors.sat_pais_id"
                          class="mr-3"
                          :label="$t('address.country')"
                          v-model="editedItem.sat_pais_id"
                          cache-items
                          flat
                          hide-details
                          auto-select-first
                          clearable
                          >
                            <template slot="selection" slot-scope="data">
                              {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                            </template>
                            <template slot="item" slot-scope="data">
                              {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                            </template>
                          </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          clearable
                          required
                          mask="#####"
                          :rules="rules.zipRules"
                          :label="$t('address.zip')"
                          :error-messages="errors.zip_code"
                          v-model="editedItem.zip_code"
                          @keyup.enter="save"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6 v-if="userLogged.roles[0].id === 1">
                        <v-select
                          v-model="editedItem.company.id"
                          :label="$t('branch.company')"
                          :items="companies"
                          required
                          :rules="rules.required"
                          :error-messages="errors.branch_name"
                          item-text="name"
                          item-value="id"></v-select>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary darken-1"
                  round
                  flat
                  @click="close"
                >
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  round
                  depressed
                  :loading="loading"
                  :disabled="loading"
                  @click="save"
                >
                  {{ $t('general.save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-layout>
      <v-data-table
        :search="branchSearch"
        class="elevation-2"
        :headers="headers"
        :items="branchesList"
        :loading="loadingItems"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination"
      >
      <template v-slot:headers="props">
        <tr class="bg-heavy-rain">
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            <h2 class="font-weight-black primary--text mb-0">
              <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
              {{ header.text }}
            </h2>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <td width="60px">{{props.item.id}}</td>
          <td class="text-sm-center">{{props.item.branch_name}}</td>
          <td class="text-sm-center">{{props.item.street}}</td>
          <td class="text-sm-center">{{props.item.city}}</td>
          <td class="text-sm-center">{{props.item.state}}</td>
          <td class="text-sm-center">{{props.item.country ? props.item.country.descripcion : ''}}</td>
          <td class="text-sm-center">{{props.item.zip_code}}</td>
          <td class="text-sm-center" v-if="userLogged.roles[0].id === 1">{{props.item.company.name}}</td>
          <td width="200px">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  outline
                  icon
                  color="info"
                  v-on="on"
                  @click="editItem(props.item)"
                >
                  <v-icon small>edit</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('general.edit') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  outline
                  icon
                  color="error"
                  v-on="on"
                  @click="removed(props.item)"
                >
                <v-icon small>delete</v-icon>
              </v-btn>
              </template>
              <span>{{ $t('general.delete') }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      </v-data-table>
      <v-dialog
        persistent
        v-model="removeDialog"
        max-width="500px"
      >
        <v-card>
          <v-toolbar
            flat
          >
            <h2 class="font-weight-black error--text mb-0">{{ $t('general.deleteElement') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black"><span class="error--text">{{ $t('general.name')}}: </span>{{removedItem.branch_name}}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              color="error"
              round
              depressed
              :loading="loading"
              :disabled="loading"
              @click="removeItem(removedItem)"
            >
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'BranchesComponent',
  data () {
    return {
      branchSearch: '',
      dialog: false,
      removeDialog: false,
      loading: false,
      loadingItems: true,
      valid: true,
      editedIndex: -1,
      removedItem: {},
      originalItem: {},
      satPais: [],
      originalCompanyId: null,
      errors: {},
      items: [],
      search: null,
      editedItem: {
        id: null,
        branch_name: '',
        street: '',
        city: '',
        state: '',
        sat_pais_id: 151,
        zip_code: '',
        company: {
          id: null
        }
      },
      defaultItem: {
        id: null,
        branch_name: '',
        street: '',
        city: '',
        state: '',
        sat_pais_id: 151,
        zip_code: '',
        company: {
          id: null
        }
      },
      userLogged: {
        roles: [
          {
            id: null
          }
        ],
        company: [
          {
            id: null
          }
        ]
      },
      processedBranches: [],
      branches: [],
      branchesByCompany: {},
      branchesCompanies: [],
      companies: [],
      pagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      }
    }
  },
  computed: {
    heading () {
      return this.$t('general.branches')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'far fa-building fa-fw icon-color'
    },
    // watch the dialog title
    formTitle () {
      return this.editedIndex === -1 ? this.$t('branch.add') : this.$t('branch.edit')
    },
    // branchesNumber () {
    //   return this.branches.length
    // }
    rules () {
      return this.$validationRules()
    },
    headers () {
      let items = [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true
        },
        {
          text: this.$t('general.name'),
          align: 'center',
          value: 'branch_name',
          sortable: true
        },
        {
          text: this.$t('address.street'),
          align: 'center',
          value: 'street',
          sortable: true
        },
        {
          text: this.$t('address.city'),
          align: 'center',
          value: 'city',
          sortable: true
        },
        {
          text: this.$t('address.state'),
          align: 'center',
          value: 'state',
          sortable: true
        },
        {
          text: this.$t('address.country'),
          align: 'center',
          value: 'country',
          sortable: true
        },
        {
          text: this.$t('address.zip'),
          align: 'center',
          value: 'zip_code',
          sortable: true
        },
        {
          text: this.$t('general.company'),
          align: 'center',
          value: 'company.name',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
      if (this.userLogged.roles[0].id === 2) {
        items.splice(7, 1)
      }
      return items
    },
    branchesList () {
      if (this.userLogged.roles[0].id === 1) {
        return this.processedBranches
      } else if (this.userLogged.roles[0].id === 2) {
        return this.branchesByCompany.branch
      }
    },
    dataArrayFilter () {
      return this.$searchCountry()
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    branchesCompanies () {
      if (this.userLogged.roles[0].id === 2) {
        let company = this.branchesCompanies.find(item => item.id === this.userLogged.company[0].id)
        this.branchesByCompany = company
      }
    },
    '$store.state.userLogged' () {
      this.getLogged()
    },
    search (val) {
      this.querySelection(val)
      this.dataArrayFilter.search(this.editedItem.sat_pais_id, val)
    }
  },
  created () {
    this.getLogged()
    this.get()
  },
  methods: {
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    // set the item that want to remove and open the dialog
    removed (item) {
      this.removedItem = item
      this.removeDialog = true
    },
    removeItem (item) {
      this.loading = true
      this.editedIndex = this.branches.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.delete()
    },
    closeDelete () {
      this.removeDialog = false
      this.close()
    },
    // close the dialog and re-assing default values
    close () {
      this.loading = false
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedItem.company = Object.assign({}, { id: null })
      this.originalItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.$refs.form.resetValidation()
    },
    // show the element that want to edit
    editItem (item) {
      if (this.userLogged.roles[0].id === 1) {
        this.editedItem = Object.assign({}, item)
        this.editedIndex = this.branches.indexOf(item)
        this.originalItem = Object.assign({}, item)
        this.editedItem.company.id = item.company.id
        this.originalCompanyId = item.company.id
      } else if (this.userLogged.roles[0].id === 2) {
        this.editedItem = Object.assign({}, item)
        this.editedIndex = this.branchesByCompany.branch.indexOf(item)
        this.originalItem = Object.assign({}, item)
        this.editedItem.company = {}
        this.editedItem.company.id = item.pivot !== undefined ? item.pivot.company_id : item.company[0].id
        this.originalCompanyId = item.pivot !== undefined ? item.pivot.company_id : item.company[0].id
      }
      if (this.editedItem.sat_pais_id) {
        this.items.push(this.editedItem.sat_pais_id)
      }

      this.dialog = true
    },
    // evaluate the form and save de values
    save () {
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.userLogged.roles[0].id === 2) {
          this.editedItem.company = {}
          this.editedItem.company.id = this.userLogged.company[0].id
        }
        if (this.editedIndex > -1) {
          this.put()
        } else {
          this.post()
        }
      }
    },
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    // Load initial elements
    get () {
      this.$emit('get', {
        context: this
      })
    },
    post () {
      this.$emit('post', {
        item: this.editedItem,
        context: this
      })
    },
    put () {
      this.$emit('put', {
        item: this.editedItem,
        originalCompanyId: this.originalCompanyId,
        originalItem: this.originalItem,
        index: this.editedIndex,
        context: this
      })
    },
    delete () {
      this.$emit('delete', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this
      })
    },
    refresh () {
      this.$emit('refresh', {
        context: this
      })
    },
    querySelection (val) {
      this.items = this.dataArrayFilter.querySelection(this.satPais, val)
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/branches.component.vue